"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const util_1 = require("@app/util");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const input_1 = require("../../input");
const DateInput = ({ control, name, label, disabled, rules, min, max, testid, }) => {
    const { field, fieldState } = (0, react_hook_form_1.useController)({ control, name, rules });
    // Pre-format the value to be a correct date string
    const value = (0, util_1.isDefined)(field.value) && (0, util_1.isNotNull)(field.value)
        ? (0, moment_1.default)(field.value).format('YYYY-MM-DD')
        : undefined;
    return (react_1.default.createElement(input_1.Input, { type: 'date', size: 'full-width', label: label, min: min, max: max, testid: testid, disabled: field.disabled || disabled, 
        // @ts-expect-error
        innerRef: field.ref, value: value, onChange: field.onChange, onBlur: field.onBlur, name: field.name, hasError: (0, util_1.isValue)(fieldState.error?.message), errorMessage: fieldState.error?.message }));
};
exports.DateInput = DateInput;
